var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":_vm.position === _vm.TOP,"right":_vm.position === _vm.RIGHT,"left":_vm.position === _vm.LEFT,"bottom":_vm.position === _vm.BOTTOM,"disabled":_vm.disabled,"z-index":"30","color":_vm.color},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("default",null,{"on":on,"attrs":attrs})]}}],null,true)},[_c('span',{class:_vm.contentClass},[_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }